/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import uniqid from 'uniqid';
import { Picture } from '@bwoty-web/styleguide';
import { ExpandableLink, ArrowLink } from '@bwoty-web/styleguide2/link';

import './partInfo.scss';

const PartInfo = ({ roomType, texts, toggleRoomInfo }) => {
  const [showAllRooms, setShowAllRooms] = useState(false);

  useEffect(() => {
    const popupBody = document.getElementsByClassName('gw-room-type-popup--scroll-anchor');
    if (popupBody && popupBody.length) {
      popupBody[0].scrollIntoView();
    }
  }, [roomType?.meta?.id]);

  if (!roomType || !roomType?.part) {
    return null;
  }

  return (
    <div className="gw-part-info">
      <h3 className="gw-part-info__name">{roomType?.part?.name}</h3>
      {roomType?.part?.texts?.description && (
        <div className="gw-part-info__description" dangerouslySetInnerHTML={{ __html: roomType?.part?.texts?.description }} />
      )}
      <div className="gw-part-info__table-heading">{texts?.roomTypePopupPlacementHeading}</div>
      <div>
        {(roomType?.part?.floorPlan?.roomsShort || [])
          .filter((rt) => rt.id === roomType?.meta?.id)
          .map((rt) => (
            <div key={rt.id} className="gw-part-info__room">
              <img className="gw-part-info__room-image" src={rt.image.src} alt="" />
              {rt.name}
            </div>
          ))}
        {showAllRooms && (roomType?.part?.floorPlan?.roomsShort || [])
          .filter((rt) => rt.id !== roomType?.meta?.id)
          .map((rt) => (
            <div key={uniqid('gw-part-info-button-')} className="gw-part-info__room">
              <img className="gw-part-info__room-image" src={rt.image.src} alt="" />
              <ArrowLink name="roomButton" onClick={() => { toggleRoomInfo(rt.id); }}>{rt.name}</ArrowLink>
            </div>
          ))}
        <ExpandableLink isOpen={showAllRooms} className="gw-part-info__expand-link" onClick={() => setShowAllRooms(!showAllRooms)}>
          {showAllRooms ? texts?.roomTypePopupShowLess : texts?.roomTypePopupShowMore}
        </ExpandableLink>
        {roomType?.part?.floorPlan?.images?.length && (
          <div className="gw-part-info__images">
            {roomType?.part?.floorPlan?.images?.map((picture) => (
              <Picture
                key={uniqid('gw-part-info-picture-')}
                sources={picture?.sources}
                lazy
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

PartInfo.propTypes = {
  roomType: PropTypes.shape({
    meta: PropTypes.shape({
      id: PropTypes.number,
    }).isRequired,
    name: PropTypes.string,
    concept: PropTypes.shape({
      name: PropTypes.string,
      texts: PropTypes.shape({
        description: PropTypes.string,
      }),
      usps: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.string),
      }),
    }),
    part: PropTypes.shape({
      name: PropTypes.string,
      texts: PropTypes.shape({
        description: PropTypes.string,
      }),
      floorPlan: PropTypes.shape({
        images: PropTypes.arrayOf(PropTypes.shape({
          sources: PropTypes.arrayOf(PropTypes.shape({
            srcSet: PropTypes.string,
            type: PropTypes.string,
            media: PropTypes.string,
          })),
          fallback: PropTypes.shape({
            alt: PropTypes.string,
            role: PropTypes.string,
            src: PropTypes.string,
            srcSet: PropTypes.string,
          }),
          text: PropTypes.string,
        })),
        roomsShort: PropTypes.arrayOf(PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          image: PropTypes.shape({
            src: PropTypes.string,
          }),
        })),
      }),
    }),
    images: PropTypes.shape({
      floorPlans: PropTypes.arrayOf(PropTypes.shape({
        sources: PropTypes.arrayOf(PropTypes.shape({
          srcSet: PropTypes.string,
          type: PropTypes.string,
          media: PropTypes.string,
        })),
        fallback: PropTypes.shape({
          alt: PropTypes.string,
          role: PropTypes.string,
          src: PropTypes.string,
          srcSet: PropTypes.string,
        }),
        text: PropTypes.string,
      })),
      gallery: PropTypes.arrayOf(PropTypes.shape({
        sources: PropTypes.arrayOf(PropTypes.shape({
          srcSet: PropTypes.string,
          type: PropTypes.string,
          media: PropTypes.string,
        })),
        fallback: PropTypes.shape({
          alt: PropTypes.string,
          role: PropTypes.string,
          src: PropTypes.string,
          srcSet: PropTypes.string,
        }),
        text: PropTypes.string,
      })),
    }),
    texts: PropTypes.shape({
      description: PropTypes.string,
    }),
  }).isRequired,
  texts: PropTypes.shape({
    roomTypePopupPlacementHeading: PropTypes.string,
    roomTypePopupShowLess: PropTypes.string,
    roomTypePopupShowMore: PropTypes.string,
  }).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
};

export default PartInfo;
